import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AGE_POLICY_VERSION } from '../utils/agePolicy';

export default function PrivacyPolicyPage() {
  const { t, i18n } = useTranslation();
  return <main className="mx-auto max-w-4xl space-y-5 px-4 py-10 text-gray-700">
    <h1 className="text-3xl font-bold text-gray-900">{t('agePolicy.privacyTitle')}</h1>
    <p>{t('terms.lastUpdated')}: {AGE_POLICY_VERSION}</p>
    {[1, 2, 3, 4].map(number => <p key={number}>{t(`terms.section4.content${number}`)}</p>)}
    <h2 className="text-xl font-semibold">{t('agePolicy.title')}</h2>
    <p>{t('terms.section11.content1')}</p>
    <p>{t('terms.contact.content')}</p>
    <Link className="text-blue-600 underline" to={`/${i18n.language}/terms-and-conditions`}>{t('register.termsAndConditions')}</Link>
  </main>;
}
